import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=e7c2482e&scoped=true"
import script from "./NewCompany.vue?vue&type=script&lang=js"
export * from "./NewCompany.vue?vue&type=script&lang=js"
import style0 from "./NewCompany.vue?vue&type=style&index=0&id=e7c2482e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c2482e",
  null
  
)

export default component.exports